module.exports = __webpack_public_path__ + "f19d272c49e0982b66b77092a169c3e7.MP3";